import { UploadFile } from './../../../shared/models/documents.model';
import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { AdminRepositoryService } from 'src/app/services/admin-repository.service';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { UserRepositoryService } from 'src/app/services/user-repository.service';
import { CreateEditDialog, HomePageContents, Links } from 'src/app/shared/models/admin.model';
import moment from 'moment';
import { SECTION_TYPE } from 'src/app/app.constants';

@Component({
  selector: 'app-create-edit-news-updates-dialog',
  templateUrl: './create-edit-news-updates-dialog.component.html',
  styleUrls: ['./create-edit-news-updates-dialog.component.scss']
})
export class CreateEditNewsUpdatesDialogComponent implements OnInit {

  newsUpdatesForm: UntypedFormGroup;
  tooltipOptions: Object;
  linkTypeOptions = ['Document', 'URL'];
  typeOptions = ['Document', 'Date', 'Policy'];
  linkTypeSelected: string;
  isEditNewsUpdate: boolean;
  typeSelected: string;
  linkList:Links[]=[];
  private linkListAddress:string;
  private unsubscribe: Subject<void> = new Subject<void>(); 
  isLoadingData: boolean;
  modalHeaderTitle: string;
  /* hide past date and year in date picker Start */
  today = new Date();
  tomorrow = new Date();
  /* hide past date and year in date picker end */
  payloadArray={
    enabled:false
  }
  newsAndUpdateData: any;
  sectionId: any;
  isActive: any;
  homeNewsUpdatePageConentsList: any;
  secName = SECTION_TYPE.NewsNUpdatesManagement;
  enableButtonOnCrossClick:  boolean = true;
  isExtensionNotValid: boolean;
  constructor(private userRepository: UserRepositoryService,
              private snackBarService: SnackBarService,
              private adminRepository: AdminRepositoryService,
              private fb: UntypedFormBuilder, 
              private dialogRef: MatDialogRef<CreateEditNewsUpdatesDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: CreateEditDialog,) {
                this.tomorrow.setDate(this.today.getDate());
               }

  ngOnInit(): void {
    this.typeSelected = this.data.isEdit == true ? this.data.data.sectionDetailJson.type : this.typeOptions[0];
    this.linkTypeSelected = this.linkTypeOptions[0];
    this.modalHeaderTitle = this.data.isEdit  === true ? 'Edit News & Updates' : 'Add News & Updates';
    this.sectionFormInitialize();
    this.isEditNewsUpdate = this.data.isEdit === true ? true : false;
    if(this.data.isEdit) {
      this.newsAndUpdateData = this.data.data;
      this.loadTableData();
      // this.setNewsUpdateFormValue(this.newsAndUpdateData);
    }
  }

  loadTableData() {
    this.isLoadingData = true;
    this.adminRepository.getAllHomePageConents(this.secName)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((homePageConents: HomePageContents) => {
        if(homePageConents) {
          this.homeNewsUpdatePageConentsList = homePageConents;
          if(this.homeNewsUpdatePageConentsList.length > 0){
              this.setNewsUpdateFormValue(this.newsAndUpdateData);
          }
          this.isLoadingData = false; 
        }
      });
  }

  sectionFormInitialize() {   
    this.newsUpdatesForm = this.fb.group({
      startDate: this.fb.control(new Date(), [Validators.required]),
      daytoShow: this.fb.control(30, [Validators.required]),
      type: this.fb.control('', [Validators.required]),
      highImportant: this.fb.control(false),
      isUrgent: this.fb.control(false),
      isDeleted: this.fb.control(false),
      title: this.fb.control('', [Validators.required]),
      description: this.fb.control('', [Validators.required]),
      linkListGroup: this.fb.group({
        linkName: this.fb.control(''),
        linkType: this.fb.control(''),
        url: this.fb.control(''),
        fileUpload: this.fb.control(''),
      })
    });
    this.linkListGroup.valueChanges.pipe(debounceTime(500), distinctUntilChanged())
      .subscribe(val => {
          if(val.linkType == 'URL') {
            if(val.linkName !== '' && val.linkType !== '' && val.url !== '') {
              this.payloadArray.enabled = true;
            } else {
              this.payloadArray.enabled = false;
            }
          } else {
            if(val.linkName !== '' && val.linkType !== '' && val.fileUpload !== '') {
              this.payloadArray.enabled = true;
            } else {
              this.payloadArray.enabled = false;
            }
          }
      });
  }

  onOptionChange(event) {
    this.linkTypeSelected = event.value;
  }

  getNewsUpdateFormValue() {
    return {
      sectionId: this.data.isEdit ? this.data.data.sectionId : '',
      startDate: this.startDate.value.toLocaleString("en-US"),
      daytoShow: this.daytoShow.value,
      type: this.type.value,
      highImportant: this.highImportant.value,
      title: this.title.value,
      description: this.description.value,
      linkName: this.linkName.value,
      linkType: this.linkType.value,
      url: this.url.value,
      fileUpload: this.fileUpload.value,
      isUrgent: this.data.isEdit ? this.isUrgent.value : false,
      isDeleted: this.data.isEdit ? this.isDeleted.value : false
    }
  }

  setNewsUpdateFormValue(formInfo) {
    const sectionLinks = this.homeNewsUpdatePageConentsList.filter(a => a.sectionId == formInfo.sectionId);

    this.newsUpdatesForm.patchValue({
      startDate: sectionLinks[0].sectionDetailJson.startDate,
      daytoShow: sectionLinks[0].sectionDetailJson.daysToShow,
      type: sectionLinks[0].sectionDetailJson.type,
      isUrgent: sectionLinks[0].sectionDetailJson.isUrgent,
      isDeleted: sectionLinks[0].sectionDetailJson.isDeleted,
      title: sectionLinks[0].sectionDetailJson.sectionHeader,
      description: sectionLinks[0].sectionDetailJson.sectionDescription,
      //links: formInfo.sectionDetailJson.linkList
    });
    this.linkList = sectionLinks[0].sectionDetailJson.links;
    this.sectionId = sectionLinks[0].sectionId;
    this.isActive = sectionLinks[0].isActive;
  }

  onSaveClick() {
    this.isLoadingData = true;
    let formValues = this.getNewsUpdateFormValue();
    let saveForm: HomePageContents = {
      sectionId: '',      
      sectionDetailJson: {
        staticContentName:'NewsAndUpdatesManagement',
        startDate: moment(formValues.startDate).format('MM/DD/YYYY'),
        sectionHeader: formValues.title,
        sectionDescription: formValues.description,
        daysToShow: formValues.daytoShow,
        type: formValues.type,
        highImportance: formValues.highImportant,
        links: this.linkList
      },
     comments: null,
    // isActive: formValues.isActive
    }
    this.adminRepository.saveStaticContent(saveForm)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(data => {
        if (data) {
          this.dialogRef.close(true);
          this.snackBarService.showSuccess('News & Update Content has been successfully added/updated');
          this.isLoadingData = false;
        }
      }, err => {
        this.dialogRef.close(false);
        this.isLoadingData = false;
      });
  }

  onCancelClick() {
    this.dialogRef.close();
  }

  onUploadFile(){
    let linkList: Links = new Links();
    linkList.linkTitle = this.linkName.value;
    linkList.linkType = this.linkTypeSelected;
    if (this.linkTypeSelected === "URL") {
      linkList.linkAddress = this.url.value;
    } else {
      linkList.linkAddress = this.linkListAddress;
    }
    this.linkList.push(linkList);
    this.linkName.patchValue("");
    this.fileUpload.patchValue("");
    this.url.patchValue("");
  }

  onFileSelected(event){
      const  file:File=event.target.files[0];
      this.linkName.setValue(file.name)
      let formData: FormData = new FormData();
      formData.append("file", file);
    this.adminRepository.uploadStaticFile(formData).pipe(takeUntil(this.unsubscribe))
      .subscribe(
        (response: string) => {
          if (response) {
            this.linkListAddress = response;
          }
        },
        (error) => {
          if (error.status == 405) {
            this.payloadArray.enabled = false;
            this.isExtensionNotValid = true;
          } else {
            console.log(error);
          }

        }
      );
  }

  removeLinkList(ind?:number){
    let removeLinks = [];
    if(!this.data.isEdit) {
      if (ind && this.linkList[ind].linkType === "URL") {
        this.linkList.splice(ind, 1);
      } else {
        this.linkList.splice(ind, 1);
      }
    } else {
      if(ind && this.linkList[ind].linkType === "URL") {
        this.linkList.splice(ind, 1);
      } else {
        this.linkList.splice(ind, 1);
      }
    }
    this.enableButtonOnCrossClick = false;
    // if (this.linkList[ind].linkType === "URL") {
    //   this.linkList.splice(ind, 1);
    // } else {
    //   this.adminRepository
    //     .removeStaticContentFile(this.linkList[ind].linkAddress)
    //     .pipe(takeUntil(this.unsubscribe))
    //     .subscribe(
    //       (response: string) => {
    //         this.linkList.splice(ind, 1);
    //       },
    //       (error) => {
    //         console.log(error);
    //       }
    //     );
    // }

  }

  onUpdateClick() {
    this.isLoadingData = true;
    let formValues = this.getNewsUpdateFormValue();
   
    let saveForm = {
      sectionId: this.sectionId,
      sectionDetailJson: {
        staticContentName:'NewsAndUpdatesManagement',
        startDate: moment(formValues.startDate).format('MM/DD/YYYY'),
        sectionHeader: formValues.title,
        sectionDescription: formValues.description,
        daysToShow: formValues.daytoShow,
        type: formValues.type,
        highImportance: formValues.highImportant,
        links: this.linkList,
        isUrgent: formValues.isUrgent,
        isDeleted:formValues.isDeleted
      },
     comments: null,
     isActive: this.isActive
    }
    this.adminRepository.editStaticContent(saveForm)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(data => {
        if (data) {
          this.dialogRef.close(true);
          this.snackBarService.showSuccess('News & Update Content has been successfully added/updated');
          this.isLoadingData = false;
        }
      }, (error) => {
        if (error.status == 400) { 
          this.snackBarService.showError("Invalid input!");
          this.isLoadingData = false;
        }
        else {
          this.dialogRef.close(false);
          this.isLoadingData = false;
        }
      });
  }

  get startDate() {
    return this.newsUpdatesForm.get('startDate') as UntypedFormControl;
  }

  get daytoShow() {
    return this.newsUpdatesForm.get('daytoShow') as UntypedFormControl;
  }

  get type() {
    return this.newsUpdatesForm.get('type') as UntypedFormControl;
  }

  get highImportant() {
    return this.newsUpdatesForm.get('highImportant') as UntypedFormControl;
  }

  get isUrgent() {
    return this.newsUpdatesForm.get('isUrgent') as UntypedFormControl;
  }

  get isDeleted() {
    return this.newsUpdatesForm.get('isDeleted') as UntypedFormControl;
  }

  get title() {
    return this.newsUpdatesForm.get('title') as UntypedFormControl;
  }

  get description() {
    return this.newsUpdatesForm.get('description') as UntypedFormControl;
  }

  get linkName() {
    return this.newsUpdatesForm.get('linkListGroup.linkName') as UntypedFormControl;
  }

  get linkType() {
    return this.newsUpdatesForm.get('linkListGroup.linkType') as UntypedFormControl;
  }

  get url() {
    return this.newsUpdatesForm.get('linkListGroup.url') as UntypedFormControl;
  }

  get fileUpload() {
    return this.newsUpdatesForm.get('linkListGroup.fileUpload') as UntypedFormControl;
  }

  get linkListGroup() {
    return this.newsUpdatesForm.get('linkListGroup') as UntypedFormGroup;
  }

}
